import { StickerContainer } from 'dashboard/components/WorkflowStatusSticker/WorkflowStatusSticker';
import { WorkflowBlockStatus } from 'dashboard/models/workflow-block';
import {
  WorkflowVersionDeploymentStatus,
  WorkflowVersionStatus,
} from 'dashboard/models/workflow-version';
import Sticker from 'design-system/components/Sticker';
import { Variant } from 'design-system/theme';

interface WorkflowVersionStatusStickerProps {
  workflowVersionDeploymentStatus?: WorkflowVersionDeploymentStatus;
  versionStatus: WorkflowVersionStatus | WorkflowBlockStatus;
  percentage?: number;
}

const WorkflowVersionStatusSticker = ({
  workflowVersionDeploymentStatus,
  versionStatus,
  percentage,
}: WorkflowVersionStatusStickerProps) => {
  const getStickerStatus = (): [Exclude<Variant, 'inverse'>, string] => {
    if (workflowVersionDeploymentStatus && percentage) {
      switch (workflowVersionDeploymentStatus) {
        case WorkflowVersionDeploymentStatus.Treatment: {
          return ['caution', `Treatment • ${percentage}%`];
        }
        case WorkflowVersionDeploymentStatus.Control: {
          return ['primary', `Control • ${100 - percentage}%`];
        }
        default:
          return ['danger', 'Unknown'];
      }
    } else {
      switch (versionStatus) {
        case WorkflowBlockStatus.Archived:
        case WorkflowVersionStatus.Archived: {
          return ['danger', 'Archived'];
        }
        case WorkflowBlockStatus.Draft:
        case WorkflowVersionStatus.Draft: {
          return ['primary', 'Draft'];
        }
        case WorkflowBlockStatus.Published:
        case WorkflowVersionStatus.Published: {
          return ['success', 'Published'];
        }
        default:
          return ['caution', 'Unknown'];
      }
    }
  };

  const [variantType, statusMessage] = getStickerStatus();

  return (
    <StickerContainer>
      <Sticker variant={variantType}>{`Version: ${statusMessage}`}</Sticker>
    </StickerContainer>
  );
};

export default WorkflowVersionStatusSticker;
